import { css, cx } from '@linaria/core'
import type React from 'react'
import type { FC } from 'react'
import { Icon } from '#components/Icon'
import InfoIcon from '#icons/info-circle-48.svg?url'
import { style } from '#styles'

const inputClass = css`
  display: flex;
  align-items: center;
  max-width: 100%;
  height: 30px;
  gap: 16px;
  padding: 12px 12px;
  border: solid 1px ${style.themeColors.lineInput};
  background: ${style.themeColors.backgroundDefault};
  color: ${style.themeColors.textDefault};
  font-size: inherit;
  
  &[type='date'] {
    padding: 2px 5px 2px 5px;
  }

  &:hover {
    border: 1px solid ${style.themeColors.lineInputHover};
  }
  
  &:disabled {
    background: ${style.themeColors.backgroundBoxed};
    color: ${style.themeColors.textDeselected};
    border: solid 1px ${style.themeColors.textDeselected};
  }
`

const labelClass = css`
  flex-shrink: 0;
`

export const TextInput: FC<
  {
    title?: string
    required?: boolean
    tooltip?: boolean
    value?: string | number
    onChange?: React.InputHTMLAttributes<HTMLInputElement>['onChange']
  } & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = ({ title, required, tooltip, value, onChange, className, ...props }) => {
  return (
    <>
      {title && (
        <div className={cx('_label', labelClass)}>
          <span className="_text">
            {title} {required && <span className="_required">*</span>}
          </span>
          {tooltip && <Icon size="s" iconUrl={InfoIcon} />}
        </div>
      )}

      <input className={cx(inputClass, className)} value={value ?? ''} onChange={onChange} {...props} />
    </>
  )
}
